import _toConsumableArray from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _regeneratorRuntime from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _slicedToArray from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _createForOfIteratorHelper from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import { useControlledState } from "@react-stately/utils";
import _babelRuntimeHelpersEsmExtends from "@babel/runtime/helpers/esm/extends";
import { useCollection } from "@react-stately/collections";
import { SelectionManager, useMultipleSelectionState } from "@react-stately/selection";
import { useEffect, useMemo } from "react";
var $ed5d55e571caf578a4f08babbaa26be$var$_Symbol$iterator;
$ed5d55e571caf578a4f08babbaa26be$var$_Symbol$iterator = Symbol.iterator;
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

export var ListCollection = /*#__PURE__*/function () {
  function ListCollection(nodes) {
    var _this = this;

    _classCallCheck(this, ListCollection);

    var _last;

    this.keyMap = new Map();
    this.iterable = void 0;
    this.firstKey = void 0;
    this.lastKey = void 0;
    this.iterable = nodes;

    var visit = function visit(node) {
      _this.keyMap.set(node.key, node);

      if (node.childNodes && node.type === 'section') {
        var _iterator = _createForOfIteratorHelper(node.childNodes),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var child = _step.value;
            visit(child);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
    };

    var _iterator2 = _createForOfIteratorHelper(nodes),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var node = _step2.value;
        visit(node);
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }

    var last;
    var index = 0;

    var _iterator3 = _createForOfIteratorHelper(this.keyMap),
        _step3;

    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var _step3$value = _slicedToArray(_step3.value, 2),
            key = _step3$value[0],
            _node = _step3$value[1];

        if (last) {
          last.nextKey = key;
          _node.prevKey = last.key;
        } else {
          this.firstKey = key;
          _node.prevKey = undefined;
        }

        if (_node.type === 'item') {
          _node.index = index++;
        }

        last = _node; // Set nextKey as undefined since this might be the last node
        // If it isn't the last node, last.nextKey will properly set at start of new loop

        last.nextKey = undefined;
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }

    this.lastKey = (_last = last) == null ? void 0 : _last.key;
  }

  _createClass(ListCollection, [{
    key: $ed5d55e571caf578a4f08babbaa26be$var$_Symbol$iterator,
    value: /*#__PURE__*/_regeneratorRuntime.mark(function value() {
      return _regeneratorRuntime.wrap(function value$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.delegateYield(this.iterable, "t0", 1);

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, value, this);
    })
  }, {
    key: "getKeys",
    value: function getKeys() {
      return this.keyMap.keys();
    }
  }, {
    key: "getKeyBefore",
    value: function getKeyBefore(key) {
      var node = this.keyMap.get(key);
      return node ? node.prevKey : null;
    }
  }, {
    key: "getKeyAfter",
    value: function getKeyAfter(key) {
      var node = this.keyMap.get(key);
      return node ? node.nextKey : null;
    }
  }, {
    key: "getFirstKey",
    value: function getFirstKey() {
      return this.firstKey;
    }
  }, {
    key: "getLastKey",
    value: function getLastKey() {
      return this.lastKey;
    }
  }, {
    key: "getItem",
    value: function getItem(key) {
      return this.keyMap.get(key);
    }
  }, {
    key: "at",
    value: function at(idx) {
      var keys = _toConsumableArray(this.getKeys());

      return this.getItem(keys[idx]);
    }
  }, {
    key: "size",
    get: function get() {
      return this.keyMap.size;
    }
  }]);

  return ListCollection;
}();
/**
 * Provides state management for list-like components. Handles building a collection
 * of items from props, and manages multiple selection state.
 */

export function useListState(props) {
  var filter = props.filter;
  var selectionState = useMultipleSelectionState(props);
  var disabledKeys = useMemo(function () {
    return props.disabledKeys ? new Set(props.disabledKeys) : new Set();
  }, [props.disabledKeys]);

  var factory = function factory(nodes) {
    return filter ? new ListCollection(filter(nodes)) : new ListCollection(nodes);
  };

  var context = useMemo(function () {
    return {
      suppressTextValueWarning: props.suppressTextValueWarning
    };
  }, [props.suppressTextValueWarning]);
  var collection = useCollection(props, factory, context, [filter]); // Reset focused key if that item is deleted from the collection.

  useEffect(function () {
    if (selectionState.focusedKey != null && !collection.getItem(selectionState.focusedKey)) {
      selectionState.setFocusedKey(null);
    }
  }, [collection, selectionState.focusedKey]);
  return {
    collection: collection,
    disabledKeys: disabledKeys,
    selectionManager: new SelectionManager(collection, selectionState)
  };
}
/**
 * Provides state management for list-like components with single selection.
 * Handles building a collection of items from props, and manages selection state.
 */

export function useSingleSelectListState(props) {
  var _props$defaultSelecte;

  var _useControlledState = useControlledState(props.selectedKey, (_props$defaultSelecte = props.defaultSelectedKey) != null ? _props$defaultSelecte : null, props.onSelectionChange),
      _useControlledState2 = _slicedToArray(_useControlledState, 2),
      selectedKey = _useControlledState2[0],
      setSelectedKey = _useControlledState2[1];

  var selectedKeys = useMemo(function () {
    return selectedKey != null ? [selectedKey] : [];
  }, [selectedKey]);

  var _useListState = useListState(_babelRuntimeHelpersEsmExtends({}, props, {
    selectionMode: 'single',
    disallowEmptySelection: true,
    allowDuplicateSelectionEvents: true,
    selectedKeys: selectedKeys,
    onSelectionChange: function onSelectionChange(keys) {
      var key = keys.values().next().value; // Always fire onSelectionChange, even if the key is the same
      // as the current key (useControlledState does not).

      // Always fire onSelectionChange, even if the key is the same
      // as the current key (useControlledState does not).
      if (key === selectedKey && props.onSelectionChange) {
        props.onSelectionChange(key);
      }

      setSelectedKey(key);
    }
  })),
      collection = _useListState.collection,
      disabledKeys = _useListState.disabledKeys,
      selectionManager = _useListState.selectionManager;

  var selectedItem = selectedKey != null ? collection.getItem(selectedKey) : null;
  return {
    collection: collection,
    disabledKeys: disabledKeys,
    selectionManager: selectionManager,
    selectedKey: selectedKey,
    setSelectedKey: setSelectedKey,
    selectedItem: selectedItem
  };
}